// Initialize alpine
document.addEventListener('alpine:init', () => {

  Alpine.store('URL', {
    queryParams: [],
    params: {},
    baseURL: window.location.origin + window.location.pathname,
    targetSale: null,

    init() {
      const url = window.location.href;
      const start = url.indexOf('?');

      if (start !== -1) {
        const stop = url.indexOf('#') > -1 ? url.indexOf('#') : url.length;
        const queryString = start > -1 ? url.substr(start + 1, stop - start - 1) : '';

        // collect parameters
        this.queryParams = queryString.split('&').map((param) => param.split('='));
      }
      this.setTargetSale();
    },

    setTargetSale() {

      // This avoid to activate any sale which are already in cookie to prioritize target sale
      if (window.__LIF__.free_offer_product_template) {
        this.targetSale = 'freeProductTemplate';
        return;
      }

      if (window.__LIF__.gwp && window.__LIF__.gwp.metaobject_url) {
        this.targetSale = 'blackFridaySale';
        return;
      }

      if (window.__LIF__.winterBundleSalesSettings && window.__LIF__.winterBundleSalesSettings.isActive) {
        this.targetSale = 'customBundle';
        return;
      }

      if (window.__LIF__.incrementalSalesSettings && window.__LIF__.incrementalSalesSettings.isActive) {
        this.targetSale = 'incrementalSale';
        return;
      }

      if (window.__LIF__.incremental_sale_v2 && window.__LIF__.incremental_sale_v2.is_active) {
        this.targetSale = 'incrementalSale';
        return;
      }

      for (const param of Alpine.store('URL').queryParams) {
        // console.log(param);
 
        switch (param[0]) {
          case 'offer':
            this.targetSale = decodeURIComponent(param[1]) == '5sweatshirt' ? 'offerFixedPrice' : 'offer1Free';
            break;
          case 'offersettings':
            this.targetSale = 'offer1Free';
            break;
          case 'sale':
            this.targetSale = 'dynamicSale';
            break;
        }
      }

    }
  });

  // Test URL: https://www.loveinfaith.life/collections/embellished-knit-sweaters?fwp2=so-so-good-tee5404&fwpset=default
  Alpine.store('fwpOffer', { // Free With Purchase Pop-up Screen
    isFwpPopupOpen: false,
    settings: null,
    productHandle: null,
    saleDetails: null,
    offerSwitched: false,
    activationCompleted: false,
    isAlreadyActive: false,

    // This tiggers on page loadd
    init() {
      Alpine.store('URL').queryParams.forEach((param) => {
        console.log(param);
        switch (param[0]) {
          case 'fwpset' : // Check if parameter is passed for fwpset

            if (getLifCookie('LIF-PARAMS--FWP_Settings')) {
              this.isAlreadyActive = true;
            }

            // define sale expiry date
            todayMidNight = new Date();
            todayMidNight.setHours(24, 0, 0, 0); // next midnight

            offerExpiryTime = todayMidNight.getTime();
            timerExpiryTime = offerExpiryTime;

            const saleDetails = {
              saleName: decodeURIComponent(param[1]),
              saleExpiry: { offerExpiryTime, timerExpiryTime },
              targetCollection: window.location.origin + window.location.pathname,
            };

            // Activate offer 1 free for 24 hours
            setLifCookie('LIF-PARAMS--FWP_OFFER', JSON.stringify(saleDetails), 1);
            this.offerSwitched = true;

            const fwpPopupConfig = JSON.parse(document.querySelector('#fwp_popup_config[type="application/json"]').textContent);
            this.settings = fwpPopupConfig[param[1]] ? fwpPopupConfig[param[1]] : null;

            // Save to cookie
            setLifCookie('LIF-PARAMS--FWP_Settings', JSON.stringify(this.settings), 2);
          break;

          case 'fwp2':

          if (getLifCookie('LIF-PARAMS--FWP_Product_Handle')) {
            this.isAlreadyActive = true;
          }

            this.productHandle = param[1];
            setLifCookie('LIF-PARAMS--FWP_Product_Handle', this.productHandle, 2);
          break;
        }
      });

      // Check if dynamic sale is already active
      this.refreshOffer();
    },
    deactivateOtherOffers() {
      // Deactivate only if this offer is activating for first time
      if (this.isAlreadyActive) {
        return; // To void removing keys '_is_free_shirt', '_applied_offer_type'
      }
      // Deactivate all othere
      deactivateOtherOffersIfActive(
        lifOfferKeyUsed.offerFWP.cookieKeysUsed,
        lifOfferKeyUsed.offerFWP.propertyKeysUsed,
      ).then(() => {
        this.activationCompleted = true;
        Alpine.store('sale').refreshOffers();
      })
    },
    refreshOffer() {

      const fwpSettings = getLifCookie('LIF-PARAMS--FWP_Settings');
      if (fwpSettings) {
        this.settings = JSON.parse(fwpSettings);
      } else {
        this.settings = {};
      }

      const saleDetails = getLifCookie('LIF-PARAMS--FWP_OFFER');
      if (saleDetails) {
        // Save sale details to store if active
        this.saleDetails = JSON.parse(saleDetails);
      } else {
        this.saleDetails = null;
      }

      const fwpProductHandle = getLifCookie('LIF-PARAMS--FWP_Product_Handle');
      if (fwpSettings) {
        this.productHandle = fwpProductHandle;
      } else {
        this.productHandle = null;
      }

      if (this.offerSwitched && !this.hasFreeProduct) {
        this.openFwpPopup();
      }
    },
    get hasFreeProduct() {
      return !!Alpine.store('cart').cartItems.find((i) => i.properties.attributes._is_free_shirt && i.properties.attributes._applied_offer_type == 'fwp');
    },
    get hasSecondProduct() {
      return !!Alpine.store('cart').cartItems.find((i) => i.properties.attributes._fwp_second_product);
    },
    openFwpPopup() {
      this.isFwpPopupOpen = true;
      Alpine.store('screen').isScrollableBody = false;
    },
    closeFwpPopup() {
      this.isFwpPopupOpen = false;
      Alpine.store('screen').isScrollableBody = true;
    }
  });
  Alpine.store('freeProductTemplate', {
    isActive: false,
    version: null,
    atcInitiated: false,
    init() {
      // console.log('freeProductTemplate init');
      
      if (window.__LIF__.free_offer_product_template) {
        this.isActive = true;
        this.version = window.__LIF__.free_offer_product_template.version;

        if (this.isUnlocked) {
          this.updateSectionsVisibility(false);
        }

        Alpine.effect(() => {
          if (this.isUnlocked) {
            this.updateSectionsVisibility(false);
          } else {
            this.updateSectionsVisibility(true);
          }
        });
      }
    },
    updateSectionsVisibility(isShow) {
      const hideSectionsIds = ['__main', '__fwp1_image_grid_', '__fopv2_collection_grid_dnpBVA'];

      for (const sectionId of hideSectionsIds) {
        const ele = document.querySelector(".shopify-section[id*='"+sectionId+"']")
        if (ele) {
          if (isShow) {
            ele.classList.remove('hidden');
          } else {
            ele.classList.add('hidden');
          }
        }
      }

    },
    get cartFunnelProduct() {
      return Alpine.store('cart').cartItems.find((i) => i.properties.attributes._is_funnel_product);
    },
    get cartAbsoluteFreeProduct() {
      return Alpine.store('cart').cartItems.find((i) => i.properties.attributes._is_absolute_free_product);
    },
    get shouldShowNextCollection() {
      return this.atcInitiated || !!this.cartAbsoluteFreeProduct;
    },
    get isUnlocked() {
      return !!this.cartFunnelProduct && !!this.cartAbsoluteFreeProduct;
    },
    get youSaved() {
      if (!this.cartAbsoluteFreeProduct) {
        return 0;
      }
      return (this.cartAbsoluteFreeProduct.compare_at_price / 100).toFixed(2);
    }

  });

  Alpine.store('offer1Free', {
    saleDetails: null,
    offerSwitched: false,
    activationCompleted: false,
    offersettings: null,

    // This tiggers on page loadd
    init() {
      // console.log('offer1Free init: ');
      for (const param of Alpine.store('URL').queryParams) {
        console.log(param);

        switch (param[0]) {
          case 'offer' : // Check if parameter is passed for offer=1feee
            if (param[1] == '1free') {

              const saleDetails = {
                saleName: decodeURIComponent(param[1]),
                saleExpiry: null,
                targetCollection: Alpine.store('URL').baseURL,
              };

              this.saleDetails = this.saleDetails || {};
              this.saleDetails = { ...this.saleDetails, ...saleDetails };

              this.offerSwitched = true;
            }
            break;
          case 'offersettings' : // Check if parameter is passed for offer=1feee
            const collectionFunnelConfigScript = document.querySelector('#collection_funnel_config[type="application/json"]');
            if (collectionFunnelConfigScript) {

              try {
                this.offerSettings = JSON.parse(collectionFunnelConfigScript.textContent);

                this.saleDetails = this.saleDetails || {};
                this.saleDetails.offerSettingKey = param[1];
                this.saleDetails.targetCollection = Alpine.store('URL').baseURL;

                console.log(this.saleDetails);
              } catch(error) {
                console.error(error);
              };
            } else {
              console.log('Error while parsing json: ');
              console.log(collectionFunnelConfigScript);
            }
            break;
        }
      }

      if (this.saleDetails) {
        console.log('Saving sale to cookie: ');
        // console.log(this.saleDetails);

        console.log(JSON.stringify(this.saleDetails));
        // Activate offer 1 free for 24 hours
        setLifCookie('LIF-PARAMS--FREE_SHIRT_OFFER', JSON.stringify(this.saleDetails), 1);
      }

      // Check if dynamic sale is already active
      this.refreshOffer();
    },
    deactivateOtherOffers() {
      // Deactivate all othere
      deactivateOtherOffersIfActive(lifOfferKeyUsed.offer1Free.cookieKeysUsed, lifOfferKeyUsed.offer1Free.propertyKeysUsed, [], false,)
      .then(() => {
        this.activationCompleted = true;
        Alpine.store('sale').refreshOffers();

        if (!this.saleDetails) {
          return;
        }

        console.log('Remove sale if already another free offer applied; ');

        const lineItems = Alpine.store('cart').tempItems;
        if (!lineItems || lineItems.length === 0) {
          return;
        }

        for (let i = 0; i < lineItems.length; i += 1) {
          const thisItem = lineItems[i];
          const { properties: { attributes: properties } } = thisItem;
         
          // Check if offer one free is already applied for another sale
          if (properties._is_free_shirt && properties._applied_offer_type != 'Offer 1 Free') {
            // Remove free offer
            delete properties._is_free_shirt;
            delete properties._applied_offer_type;

            lineItems[i],attributes = properties;
          }
        }
  
        Alpine.store('cart').pushTempItemsToCart();
      })
    },
    refreshOffer() {

      // Check if another sale is going to active
      const { targetSale } = Alpine.store('URL');
      if (targetSale && targetSale != 'offer1Free') {
        return;
      }

      if (!isFreeShirtOfferON()) {
        this.saleDetails = null;
        return;
      }

      const saleDetails = getLifCookie('LIF-PARAMS--FREE_SHIRT_OFFER');
      const { hasAbsoluteFreeProduct } = Alpine.store('cart');

      if (saleDetails && !hasAbsoluteFreeProduct) {
        // Save sale details to store if active
        this.saleDetails = JSON.parse(saleDetails);

        // console.log('Offer 1 free: Sale activating details from cookie');
        // console.log(this.saleDetails);
      } else {
        this.saleDetails = null;
      }
    },
    get cartFunnelProducts() {
      return Alpine.store('cart').cartItems.filter((i) => i.properties.attributes._is_funnel_product);
    },
    get cartAbsoluteFreeProduct() {
      return Alpine.store('cart').cartItems.find((i) => i.properties.attributes._is_absolute_free_product);
    },
    get offerCollections() {
      if (!this.saleDetails || !this.offerSettings) {
        return null;
      }
      const collections = this.offerSettings.collections
        .filter(c => c.url_redirect)
        .map(c => c.url_redirect);

      if (collections.includes(this.saleDetails.targetCollection)) {
        // This means first collection was already completed so keep this empty
        return [ null, ...collections ];  
      }

      return [ this.saleDetails.targetCollection, ...collections ];
    },
    get offerCurrentSettings() {
      const { baseURL } = Alpine.store('URL');

      if (this.offerCollections) { 
        const settingIndex = this.offerCollections.includes(baseURL) ? this.offerCollections.indexOf(baseURL) : 0;
        return this.offerSettings.collections[settingIndex];
      }

      return null;
    } 
  });

  Alpine.store('offerFixedPrice', {
    saleDetails: null,
    offerSwitched: false,
    activationCompleted: false,

    // This tiggers on page loadd
    init() {
      // console.log('offerFixedPrice init');
      Alpine.store('URL').queryParams.forEach((param) => {
        switch (param[0]) {
          case 'offer' : // Check if parameter is passed for offer=1$5
            if (decodeURIComponent(param[1]) == '5sweatshirt') {

              const saleDetails = {
                saleName: decodeURIComponent(param[1]),
                saleExpiry: null,
                targetCollection: window.location.origin + window.location.pathname,
                price: 5,
              };

              // Activate offer 1 free for 48 hours
              setLifCookie('LIF-PARAMS--FIXED_PRICE_OFFER', JSON.stringify(saleDetails), 1);
              this.offerSwitched = true;
            }
            break;
        }
      });

      // Check if dynamic sale is already active
      this.refreshOffer();
    },
    deactivateOtherOffers() {
      // Deactivate all othere
      deactivateOtherOffersIfActive(
        lifOfferKeyUsed.offerFixedPrice.cookieKeysUsed,
        lifOfferKeyUsed.offerFixedPrice.propertyKeysUsed,
      ).then(() => {
        this.activationCompleted = true;
        Alpine.store('sale').refreshOffers();
      })
    },
    refreshOffer() {

      // Check if another sale is going to active
      const { targetSale } = Alpine.store('URL');
      if (targetSale && targetSale != 'offerFixedPrice') {
        return;
      }

      if (!isFreeShirtOfferON()) {
        this.saleDetails = null;
        return;
      }

      const saleDetails = getLifCookie('LIF-PARAMS--FIXED_PRICE_OFFER');
      const { hasAbsoluteFreeProduct } = Alpine.store('cart');

      if (saleDetails && !hasAbsoluteFreeProduct) {
        // Save sale details to store if active
        this.saleDetails = JSON.parse(saleDetails);
      } else {
        this.saleDetails = null;
      }
    }
  });

  /*
   * Create store to save dynamic sale data site wide
   */
  Alpine.store('dynamicSale', {
    saleDetails: null,
    offerSwitched: false,
    activationCompleted: false,

    // This tiggers on page loadd
    init() {
      // console.log('dynamicSale init');
      Alpine.store('URL').queryParams.forEach((param) => {
        switch (param[0]) {
          case 'sale' : // Check if parameter is passed for dynamic sale

            // define sale expiry date
            todayMidNight = new Date();
            todayMidNight.setHours(24, 0, 0, 0); // next midnight

            tommMidNight = new Date();
            tommMidNight.setHours(48, 0, 0, 0); // tom midnight

            offerExpiryTime = tommMidNight.getTime();
            timerExpiryTime = todayMidNight.getTime();

            const saleDetails = {
              saleName: decodeURIComponent(param[1]),
              saleExpiry: { offerExpiryTime, timerExpiryTime },
              targetCollection: window.location.origin + window.location.pathname,
            };

            // Save sale details to cookie
            setLifCookieByExpiryDate('LIF-PARAMS--DYNAMIC-SALE', JSON.stringify(saleDetails), tommMidNight);
            this.saleDetails = saleDetails;
            this.offerSwitched = true;

            console.log('Sale is applied.');
            break;
        }
      });

      // Check if dynamic sale is already active
      this.refreshOffer();
    },
    refreshOffer() {

      // Check if another sale is going to active
      const { targetSale } = Alpine.store('URL');
      if (targetSale && targetSale != 'dynamicSale' && targetSale != 'blackFridaySale') {
        return;
      }

      const saleDetails = getLifCookie('LIF-PARAMS--DYNAMIC-SALE');
      const { hasAbsoluteFreeProduct } = Alpine.store('cart');
      if (saleDetails) {
        // Save sale details to store if active
        this.saleDetails = JSON.parse(saleDetails);
      } else {
        this.saleDetails = false;
      }
    },

    deactivateOtherOffers() {
      const conditionalPropertyKeyUsed = [];

      // Dynamic sale should combine with bb upgrade kit only when offer initiated from checkout champ page
      const hasCCBBUpdrade = Alpine.store('cart').cartItems.find((item) => {
        const attributes = item.properties.attributes || {}; 
        return (attributes._bb_upgrade_shirt || attributes._bb_upgrade_kit) && attributes._bb_page == 'checkout-champ';
      });

      if (hasCCBBUpdrade) {
        // add this keys to NOT delete when deacticating other offers
        conditionalPropertyKeyUsed.push('_bb_upgrade_shirt');
        conditionalPropertyKeyUsed.push('_bb_upgrade_kit');
      }

      // Deactivate all othere except dynamic sale
      deactivateOtherOffersIfActive(
        [...lifOfferKeyUsed.dynamicPriceSale.cookieKeysUsed, ...lifOfferKeyUsed.blackFridaySale.cookieKeysUsed, ...lifOfferKeyUsed.blackFridaySale.sessionKeysUsed],
        [...lifOfferKeyUsed.dynamicPriceSale.propertyKeysUsed, ...lifOfferKeyUsed.blackFridaySale.propertyKeysUsed],
        [...conditionalPropertyKeyUsed]
      ).then(() => {
        this.activationCompleted = true;
        Alpine.store('sale').refreshOffers();
      })
    },
  });

  Alpine.store('customBundle', {
    settings: {},
    activeIndex: 'NONE',
    manualActiveIndex: null,
    showSuccessPopup: false,
    isCompleted: {}, // completed status for each bundle sale by key
    saleDetails: {}, // Sale details status for each bundle sale by key
    isSwitchedCustomBundleSale: false,
    offerSwitched: false,
    activationCompleted: false,
    lastFilteredItemIndex: null,
    filterCache: [],
    allowMultiple: true,
    saleKey: null,

    init() {
      // console.log('customBundle init');
      if (window.__LIF__.winterBundleSalesSettings && window.__LIF__.winterBundleSalesSettings.isActive) {

        // Expiring in 48 hours
        // const expiryTime = new Date(new Date().getTime() + 60 * 60 * 48 * 1000);

        // define unique sale key from collection handle 
        const saleKey = window.location.pathname.replace('/collections/', '');
        const saleName = saleKey.replaceAll('-', ' ');
        this.saleKey = saleKey;
  
        // Check for existing sale name
        const existingSaleDetails = getLifCookie('LIF-PARAMS--CUSTOM-BUNDLE-SALE-MULTIPLE');
        const existingSettings = window.localStorage.getItem('LIF-PARAM--CustomBundleSettings');

        let saleIndex = 0;

        // let existingSale = null;
        if (existingSaleDetails) {
          this.saleDetails = JSON.parse(existingSaleDetails);
          this.settings = JSON.parse(existingSettings);

          saleIndex = Math.max(Object.values(this.saleDetails).map(s => s.saleIndex)) + 1;
        }
  
        this.isSwitchedCustomBundleSale = false;
  
        // Check if custom bundle sale is switched from one to another
        // if (existingSale && existingSale.saleName !== saleName && !allowMultiple) {
        //   this.isSwitchedCustomBundleSale = true;
        // }

        if (!this.saleDetails[saleKey]) {

          // Convert price to local currency
          const { productPrices } = window.__LIF__.winterBundleSalesSettings;
          const localCurrencyProductPrices = productPrices.map((p) => {
            return { 
              product_types: p.product_types, 
              price: Alpine.store('currency').convertLocal(p.price) 
            };
          });

          window.__LIF__.winterBundleSalesSettings.productPrices = localCurrencyProductPrices;

          // Collect bundle settings by unique key
          this.settings[saleKey] = window.__LIF__.winterBundleSalesSettings;

          // Save bundle settings seperatly on local storage to avoid cookie storage limitation
          window.localStorage.setItem('LIF-PARAM--CustomBundleSettings', JSON.stringify(this.settings));

          // define sale expiry date
          todayMidNight = new Date();
          todayMidNight.setHours(24, 0, 0, 0); // next midnight

          tommMidNight = new Date();
          tommMidNight.setHours(48, 0, 0, 0); // tom midnight

          offerExpiryTime = tommMidNight.getTime();
          timerExpiryTime = todayMidNight.getTime();

          this.saleDetails[saleKey] = {
            saleKey,
            saleName,
            saleIndex,
            saleExpiry: { offerExpiryTime, timerExpiryTime },
            targetCollection: window.location.origin + window.location.pathname,
          };
    
          setLifCookie('LIF-PARAMS--CUSTOM-BUNDLE-SALE-MULTIPLE', JSON.stringify(this.saleDetails), 2);
          this.offerSwitched = true;
        }
      } else {
        // Read from cookie if any
        this.refreshOffer();
      }

      // console.log('customBundle settings: ');
      // console.log(this.settings);

      Alpine.effect(() => {
        if (!this.settings) {
          return;
        }

        // debugger;

        // Check if all bundle items are removed
        const { cartHasLoaded, cartBundleItems, hasBundleItem } = Alpine.store('cart');

        if (!cartHasLoaded) {
          return;
        }

        // debugger;

        // Moved this to cart delete function itself
        // if (cartBundleItems.length == 0 && hasBundleItem) {
        //   // Remove bundle item too
        //   Alpine.store('cart').removeItem(hasBundleItem.key, false);
        //   Alpine.store('cart').loadItems(); // Refresh cart items
        // }
      
        // Applicable only on sale collection page
        if (this.thisSettings) {
          const bundleKeys = this.thisSettings.bundleComponents.keys();
          for (let key of bundleKeys) {
            if (!this.includedBundleComponents.includes(key)) {
              if (this.activeIndex !== key) {
                this.activeIndex = key;
                this.applyFilter(this.activeIndex);
              }

              break;
            }
          }

          if (this.activeIndex === 'NONE') {
            this.activeIndex = 'ALL';
          }
        }

        // console.log('this.includedBundleComponents.length: ');
        // console.log(this.includedBundleComponents.length);

        for (const handle of this.saleHandles) {

          // Make sure bundle product is added when free bundle item exist in cart (To Avoid issue by using multiple tabs)
          if (this.allIncludedBundleComponents[handle].length > 0 && !this.bundleKeyProducts[handle]) {
            
            Alpine.store('cart').isLoading = true;
            
            const bundleItem = {
              id: this.settings[handle].bundleProduct.variants[0].id,
              quantity: 1,
              properties: { __is_winter_product: true, saleKey: handle },
            }
    
            Alpine.store('cart').addItems([bundleItem]);
          }

          const successPopupCookieHandle = 'LIF-PARAM-CustomBundle-SuccessPopupDone--'+handle;

          if (this.settings[handle].bundleComponents.length == this.allIncludedBundleComponents[handle].length) {

            console.log('Show success popup');
            this.isCompleted[handle] = true;

            // Check if popup already shown
            const hasSuccessPopupDone = getLifCookie(successPopupCookieHandle);

            if (!hasSuccessPopupDone) {
              this.showSuccessPopup = true;

              setLifCookie(successPopupCookieHandle, 1, 2);
            }
          } else {
            this.isCompleted[handle] = false;
            removeLifCookie(successPopupCookieHandle);
          }
        }

        // Apply filter initially
        if (this.thisSettings && this.lastFilteredItemIndex === null) {
          this.applyFilter(this.activeIndex);
        }
      })
    },
    refreshOffer() {
      // Check if another sale is going to active
      const { targetSale } = Alpine.store('URL');
      if (targetSale && targetSale != 'customBundle') {
        return;
      }

      const bundleSettings = window.localStorage.getItem('LIF-PARAM--CustomBundleSettings');
      const { hasAbsoluteFreeProduct, cartHasLoaded } = Alpine.store('cart');

      if (bundleSettings) {
        this.settings = JSON.parse(bundleSettings);
      } else {
        this.settings = {};
      }

      const saleDetails = getLifCookie('LIF-PARAMS--CUSTOM-BUNDLE-SALE-MULTIPLE');

      if (saleDetails) {
        this.saleDetails = JSON.parse(saleDetails);
      } else {
        this.saleDetails = null;
      }
    },
    deactivateOtherOffers() {
      console.log('isSwitchedCustomBundleSale: ');
      console.log(this.isSwitchedCustomBundleSale);
  
      // Deactivate all othere
      const itemPropertiesUsed = this.isSwitchedCustomBundleSale ? [] : lifOfferKeyUsed.winterBundleSaleMultiple.propertyKeysUsed;
      deactivateOtherOffersIfActive(
        this.isSwitchedCustomBundleSale ? [] : [...lifOfferKeyUsed.winterBundleSaleMultiple.cookieKeysUsed, ...lifOfferKeyUsed.winterBundleSaleMultiple.sessionKeysUsed],
        itemPropertiesUsed,
        itemPropertiesUsed,
      ).then(() => { 
        this.activationCompleted = true;
        Alpine.store('sale').refreshOffers();
      })
    },
    get selectedBundle() {
      return this.manualActiveIndex !== null ? this.manualActiveIndex : this.activeIndex;
    },
    get recentHandle() {
      if (!this.saleHandles || this.saleHandles.length == 0) {
        return null;
      }

      return this.saleHandles[this.saleHandles.length - 1];
    },
    get recentSettings() {
      return this.recentHandle ? this.settings[this.recentHandle] : null;
    },
    get recentSaleDetails() {
      return this.recentHandle ? this.saleDetails[this.recentHandle] : null;
    },
    get thisSettings() {
      return this.saleKey ? this.settings[this.saleKey] : null;
    },
    get thisSaleDetails() {
      return this.saleKey ? this.saleDetails[this.saleKey] : null;
    },
    async removeItem(index) {
      // const { cartBundleItems } = Alpine.store('cart');

      const selectedItem = this.itemsByBundleIndex[index];
      // const selectedUtem = cartBundleItems[index];
      if (selectedItem) {
        await Alpine.store('cart').removeItem(selectedItem.key, false);
        Alpine.store('cart').loadItems(); // Refresh cart items
      }
    },
    get saleHandles() {
      return this.saleDetails ? Object.keys(this.saleDetails) : [];
    },
    get bundleKeyProducts() {
      const keyProducts = {};
      for (const handle of this.saleHandles) {
        keyProducts[handle] = Alpine.store('cart').cartItems.find((item) => item.properties.attributes && item.properties.attributes.__is_winter_product && item.properties.attributes.saleKey == handle);
      }

      return keyProducts;
    },
    get bundleItems() {
      const items = {};
      for (const handle of this.saleHandles) {
        items[handle] = Alpine.store('cart').cartBundleItems.filter(i => i.properties.attributes.__winter_bundle_sale.saleKey == handle);
      }

      return items;
    },
    get thisBundleItems() {
      return this.bundleItems[this.saleKey] ? this.bundleItems[this.saleKey] : [];
    },
    get allIncludedBundleComponents() {

      const bundles = {};

      if (!Alpine.store('cart').cartHasLoaded || Alpine.store('cart').cartBundleItems.length == 0) {
        for (const handle of this.saleHandles) {
          bundles[handle] = [];
        }
        return bundles;
      }

      for (const handle of this.saleHandles) {
        bundles[handle] = this.bundleItems[handle].map((i) => parseInt(i.properties.attributes.__winter_bundle_sale.componentIndex));
        if (!bundles[handle]) {
          bundles[handle] = [];
        }
      }

      return bundles;
    },
    get includedBundleComponents() {
      return this.allIncludedBundleComponents[this.saleKey] ? this.allIncludedBundleComponents[this.saleKey] : [];
    },
    get allItemsByBundleIndex() {
      const itemsByHandle = {};
      for (const handle of this.saleHandles) {
        const items = {};
        for (let i = 0; i < this.bundleItems[handle].length; i++) {
          const itemIndex = this.bundleItems[handle][i].properties.attributes.__winter_bundle_sale.componentIndex;
          items[itemIndex] = this.bundleItems[handle][i];
        }

        itemsByHandle[handle] = items;
      }

      return itemsByHandle;

      // Alpine.store('cart').cartBundleItems((i) => i.properties.attributes.__winter_bundle_sale.componentIndex == index);
    },
    get itemsByBundleIndex() {
      return this.allItemsByBundleIndex[this.saleKey];

      // Alpine.store('cart').cartBundleItems((i) => i.properties.attributes.__winter_bundle_sale.componentIndex == index);
    },
    async applyFilter(index) {

      console.log('Apply filter: '+index);

      // Apply this filter to only of bundle page
      const currentURL = window.location.origin + window.location.pathname;
      if (this.thisSaleDetails && currentURL !== this.thisSaleDetails.targetCollection) {
        return;
      }

      if (this.lastFilteredItemIndex == index) {
        console.log('Already filted same index.');
        return;
      }

      this.lastFilteredItemIndex = index;
      let queryString = '';
      let additionalQueryString = '';

      if (this.thisSettings && this.thisSettings.bundleComponents[index]) {
        const selectedBundle = this.thisSettings.bundleComponents[index];
        console.log(selectedBundle.product_types);

        // Apply filter
        queryString = 'filter.p.product_type='+selectedBundle.product_types.join(',');
        additionalQueryString = queryString;
      } else {
        queryString = 'filter.p.product_type=';
      }

      const baseURL = window.location.origin + window.location.pathname;
      const searchURL = `${baseURL}?${queryString}`;
      // window.history.replaceState(queryString, document.title, searchURL);

      // Check if result is cached
      let res = null; // Cache to load quick from next time
      const cachedResult = this.filterCache.find(c => c.url == searchURL);
      if (cachedResult) {
        console.log('Result found in cache: '+searchURL);
        res = cachedResult.response;
      } else {
        const response = await fetch(searchURL);
        res = await response.text();

        this.filterCache.push({
          url: searchURL,
          response: res
        });
      }

      // Initialize the DOM parser
      var parser = new DOMParser();

      // Parse the text
      const doc = parser.parseFromString(res, "text/html");

      // Fetch page content and pagination content from page result
      const newContainer = doc.querySelector('#product_grid');
      const newFilter = doc.querySelector('#filter_flyout');
      const newPagination = doc.querySelector('#product_pagination');
      const newTotalResult = doc.querySelector('#total_result_count');
      const noProductElementExisting = document.getElementById('collection__no-product');

      if (!newContainer) {
        if (!noProductElementExisting) {
          let noProductElement = document.createElement('p');
          noProductElement.innerHTML = '<p id="collection__no-product" class="text-center">No product found!!!</p>';
          // document.querySelector('#product_grid').innerHTML = '';
          // document.querySelector('#product_grid').after(noProductElement);
        }

        Alpine.store('collection').hasNextPage = false;
      } else {

        if (noProductElementExisting) {
          noProductElementExisting.remove();
        }

        // Render page content to end of the page
        document.querySelector('#product_grid').innerHTML = newContainer.innerHTML;
        document.querySelector('#filter_flyout').innerHTML = newFilter.innerHTML;
        document.querySelector('#product_pagination').innerHTML = newPagination.innerHTML;
        document.querySelector('#product_pagination').innerHTML = newPagination.innerHTML;
        document.querySelectorAll('.collection__total-items').forEach((e) => {
          const totalResult = newTotalResult.innerHTML;
          const itemText = totalResult > 1 ? 'Items' : 'Item';
          e.innerHTML = `${totalResult} ${itemText}`;
        });

        // this.totalResultCount = newTotalResult.innerHTML;
        Alpine.store('collection').hasNextPage = true;
        Alpine.store('collection').additionalQueryString = additionalQueryString;
        Alpine.store('collection').reloadTrigger += Alpine.store('collection').reloadTrigger;
        Alpine.store('collection').loadFirstProduct();
      }
    },
    setActiveIndex(index) {
      this.manualActiveIndex = index;
      this.applyFilter(index);
    }
  });

  Alpine.store('blackFridaySale', {
    isActive: false,
    saleDetails: null,
    offerSettings: null,
    offerSwitched: false,
    isStickyHeader: false,
    scrollDebounce : true,
    activationCompleted: false,

    async init() {

      // console.log('blackFridaySale init');
      
      let metaObjectUrl = null;

      const saleDetails = getLifCookie('LIF-PARAMS--BLACK_FRIDAY_OFFER');
      if (saleDetails) {
        this.saleDetails = JSON.parse(saleDetails);

        if (this.saleDetails.metaObjectUrl) {
          metaObjectUrl = this.saleDetails.metaObjectUrl;
        }
      }

      if (window.__LIF__.gwp && window.__LIF__.gwp.metaobject_url) {
        if (metaObjectUrl != window.__LIF__.gwp.metaobject_url) {
          metaObjectUrl = window.__LIF__.gwp.metaobject_url;

          const saleDetails = {
            metaObjectUrl,
            saleExpiry: null,
            originalTargetCollection: Alpine.store('URL').baseURL,
            targetCollection: Alpine.store('URL').baseURL,
          };

          setLifCookie('LIF-PARAMS--BLACK_FRIDAY_OFFER', JSON.stringify(saleDetails), 1);
          this.offerSwitched = true;
        }
      }

      if (metaObjectUrl) {
        try {

          // const storageKey = 'LIF-PARAMS--BlackFridaySettings'+metaObjectUrl.replaceAll('/', '.');
          const storageKey = 'LIF-PARAMS--BlackFridaySettings';

          const blackFridaySettings = window.sessionStorage.getItem(storageKey);
          if (blackFridaySettings) {
            this.offerSettings = JSON.parse(blackFridaySettings);
          } else {
            const response = await fetch(metaObjectUrl);
            this.offerSettings = await response.json();

            window.sessionStorage.setItem(storageKey, JSON.stringify(this.offerSettings));
          }

          // console.log('........................... Activating sale now.................................................................');
          this.isActive = true;

          if (!this.offerSwitched) {
            this.activationCompleted = true;
          }
        } catch(error) {
          console.error(error);
        };

        this.refreshOffer();
      }

      if (this.offerSettings && this.offerSettings.enable_sticky_header == 'true') {
        // Detect sticky header
        window.onscroll = () => {

          const productGrid = document.getElementById('product_grid');
          if (productGrid) {
            const rect = productGrid.getBoundingClientRect();
            // console.log(rect.top);

            const targetRectTop = Alpine.store('screen').isMobile ? 280 : 320;
            if (rect.top < targetRectTop) {
              this.isStickyHeader = true;
              // console.log('isStickyHeader YES.');
            } else {
              this.isStickyHeader = false;
              // console.log('isStickyHeader NO.');
            }
          }
        };
      }

      // Hide additional bundle item tag after bundle completion 
      
      setTimeout(() => {
        this.adjustBundleTag('blackfriday-bundle-item');
      }, 500);
      
    },
    adjustBundleTag(className) {
      console.log('Hide additional bundle item tag after bundle completion');
      const elements = document.querySelectorAll('.'+className);
      const elementsList = [...elements];
      const finalElements = elementsList.reverse();  // Now the reverse function will work

      // Hide additional item tag
      finalElements.forEach((e, i) => {
        if (i >= Alpine.store('blackFridaySale').highestOfferThreshold) {
          e.classList.add('hidden');
        } else {
          e.classList.remove('hidden');
        }
      });
    },
    get excludedProductTags() {
      if (!this.offerSettings) {
        return [];
      }
      return this.offerSettings.excluded_product_tags.split(',').map(t => t.trim().toLowerCase()).filter(t => t);
    },
    get excludedProductTypes() {
      if (!this.offerSettings) {
        return [];
      }
      return this.offerSettings.excluded_product_types.split(',').map(t => t.trim().toLowerCase()).filter(t => t);
    },
    get offers() {
      if (!this.offerSettings) {
        return [];
      }
      return [
        { index: 0, ...this.offerSettings.offer_1 }, 
        { index: 1, ...this.offerSettings.offer_2 }, 
        { index: 2, ...this.offerSettings.offer_3 },
      ];
    },
    get activeOffer() {
      // Check if any offer is active
      return this.offers.find(o => o.threshold <= this.bundleItems.length && !this.offerItemsByIndex[o.index]);
    },
    get highestOfferThreshold() {
      if (!this.offerSettings) {
        return null;
      }
      return Math.max(...this.offers.map(o => o.threshold));
    },
    get offerItems() {
      return Alpine.store('cart').cartItems.filter((i) => 
        i.properties.attributes.__black_friday_sale 
        && i.properties.attributes.__black_friday_sale.isOfferProduct
      );
    },
    get offerItemsByIndex() {
      const offerItems = [];
      for(const item of this.offerItems) {
        const offerIndex = item.properties.attributes.__black_friday_sale.index;
        offerItems[offerIndex] = item;
      }

      return offerItems;
    },
    get bundleItems() {
      return Alpine.store('cart').cartItems.filter((i) => 
        i.properties.attributes.__black_friday_sale 
        && i.properties.attributes.__black_friday_sale.isBundleProduct
      );
    },
    isAllowedBundleProduct(product) {
      const allowedTags = this.excludedProductTags.every(t => !product.tags.map(g => g.toLowerCase()).includes(t));
      const allowedType = this.excludedProductTypes.every(t => !product.product_type.toLowerCase().includes(t));

      console.log('isAllowedBundleProduct: allowedTags: '+allowedTags+', allowedType: '+allowedType);

      return allowedTags && allowedType;
    },
    refreshOffer() {

      // Check if another sale is going to active
      const { targetSale } = Alpine.store('URL');
      if (targetSale && targetSale != 'blackFridaySale' && targetSale != 'dynamicSale') {
        this.offerSettings = null;
        this.saleDetails = null;
        this.isActive = false;
        this.activationCompleted = false;
        return;
      }

      const offerSettings = window.sessionStorage.getItem('LIF-PARAMS--BlackFridaySettings');

      // console.log('Black friday sale: Sale activating details from session');
      // console.log(this.saleDetails);

      if (offerSettings) {
        this.offerSettings = JSON.parse(offerSettings);
      } else {
        this.offerSettings = null;
      }

      const saleDetails = getLifCookie('LIF-PARAMS--BLACK_FRIDAY_OFFER');

      if (saleDetails && this.offerSettings) {
        // Save sale details to store if active
        this.saleDetails = JSON.parse(saleDetails);
        this.saleDetails.saleName = this.offerSettings.cart_page_sale_tag;

        // replace target collection
        // Check if swap_primary_collection defined
        for (const swapInfo of this.offerSettings.swap_primary_collection) {
          if (swapInfo.threshold <= this.bundleItems.length + 1) {
            this.saleDetails.targetCollection = '/collections/'+swapInfo.collection;
          }
        }
      } else {
        this.saleDetails = null;
        this.isActive = false;
        this.activationCompleted = false;
      }
    },
    get showNowURL() {
      if (!this.activeOffer && !this.saleDetails) {
        return null;
      }
      return this.activeOffer ? '/collections/'+this.activeOffer.offer_collection : this.saleDetails.targetCollection;
    },
    deactivateOtherOffers() {
      // Deactivate all othere except dynamic sale
      deactivateOtherOffersIfActive(
        [...lifOfferKeyUsed.dynamicPriceSale.cookieKeysUsed, ...lifOfferKeyUsed.blackFridaySale.cookieKeysUsed, ...lifOfferKeyUsed.blackFridaySale.sessionKeysUsed],
        [...lifOfferKeyUsed.dynamicPriceSale.propertyKeysUsed, ...lifOfferKeyUsed.blackFridaySale.propertyKeysUsed],
        [],
        false,
      ).then(() => {
        console.log('deactivateOtherOffersIfActive then........................................')
        console.log('URL: '+Alpine.store('URL').baseURL);

        console.log('Apply sale to existing cart items too: ');

        const lineItems = Alpine.store('cart').tempItems;
        console.log('lineItems: ');
        console.log(lineItems);

        if (!lineItems || lineItems.length === 0) {
          return;
        }

        for (let i = 0; i < lineItems.length; i += 1) {
          const thisItem = lineItems[i];
          const { properties: { attributes: properties }, product_type: productType } = thisItem;
          const cartItemPrice = thisItem.price / 100;

          if (!properties.__black_friday_sale) {
            properties.__black_friday_sale = { isBundleProduct: true };
          }
        }

        console.log('pushTempItemsToCart: ');
        setTimeout(() => {
          Alpine.store('cart').pushTempItemsToCart();
        }, 2000); // This avoid to execute before cart is cleared

        Alpine.store('sale').refreshOffers();
        this.activationCompleted = true;
      });
    }
  });
            
  Alpine.store('incrementalSale', {
    settings: null,
    showSuccessPopup: false,
    offerSwitched: false,
    saleDetails: null,
    
    init() {

      // console.log('incrementalSale init: ');
      if (window.__LIF__.incrementalSalesSettings && window.__LIF__.incrementalSalesSettings.isActive) {

        Alpine.store('URL').queryParams.forEach((param) => {
          if (param[0] == 'offer' && ['valentine117', 'winter117', 'bf117'].includes(param[1])) {
            this.settings = window.__LIF__.incrementalSalesSettings;

            // Save to cookie
            setLifCookie('LIF-PARAM-IncrementalSaleSettings', JSON.stringify(this.settings), 2);

            // define sale expiry date
            todayMidNight = new Date();
            todayMidNight.setHours(24, 0, 0, 0); // next midnight

            tommMidNight = new Date();
            tommMidNight.setHours(48, 0, 0, 0); // tom midnight

            offerExpiryTime = tommMidNight.getTime();
            timerExpiryTime = todayMidNight.getTime();

            this.saleDetails = {
              saleName: this.settings.others.saleName,
              saleExpiry: { offerExpiryTime, timerExpiryTime },
              targetCollection: window.location.origin + window.location.pathname,
              offerCode: param[1],
            };

            // Check if offer is already activate
            const existingSaleDetails = getLifCookie('LIF-PARAMS--INCREAMENTAL_SALE');
            if (existingSaleDetails) {
              const saleDetails = JSON.parse(existingSaleDetails);
              if (saleDetails.saleName != this.saleDetails.saleName) {
                this.offerSwitched = true;  
              }
            } else {
              this.offerSwitched = true;
            }

            setLifCookie('LIF-PARAMS--INCREAMENTAL_SALE', JSON.stringify(this.saleDetails), 2);
          }
        });
      } else {
        this.refreshOffer();
      }
    },
    refreshOffer() {

      // Check if another sale is going to active
      const { targetSale } = Alpine.store('URL');
      if (targetSale && targetSale != 'incrementalSale') {
        return;
      }

      // Read from cookie if any
      const saleSettings = getLifCookie('LIF-PARAM-IncrementalSaleSettings');

      if (saleSettings) {
        this.settings = JSON.parse(saleSettings);
      } else {
        this.settings = {};
      }

      const saleDetails = getLifCookie('LIF-PARAMS--INCREAMENTAL_SALE');

      if (saleDetails) {
        this.saleDetails = JSON.parse(saleDetails);
      } else {
        this.saleDetails = null;
      }
    },
    deactivateOtherOffers() {
      // Deactivate all othere
      deactivateOtherOffersIfActive(
        lifOfferKeyUsed.incrementalSale.cookieKeysUsed,
        lifOfferKeyUsed.incrementalSale.propertyKeysUsed,
        [],
        false,
      ).then(() => {
        this.activationCompleted = true;
        Alpine.store('sale').refreshOffers();

        if (!this.saleDetails) {
          return;
        }

        console.log('Apply sale to existing cart items too: ')
        // const { saleName, offerCode } = this.saleDetails;
        const { saleDetails: { saleName, offerCode }, priceTiers, settings } = Alpine.store('incrementalSaleV2');

        // Apply sale to existing cart items too
        const tempCartItems = Alpine.store('cart').tempItems;
        if (!tempCartItems || tempCartItems.length === 0) {
          return;
        }
        const lineItems = tempCartItems;
        let bundleItemCount = 0;
        // const salePrice = 11;  

        for (let i = 0; i < lineItems.length; i += 1) {
          const thisItem = lineItems[i];
          const { properties: { attributes: properties }, product_type: productType } = thisItem;
          const cartItemPrice = thisItem.price / 100;
  
          // Check if sale is already applied
          
          if (
            (!properties.__incremental_sale || properties.__incremental_sale.offerCode !== offerCode) &&
            !properties.__winter_bundle_sale &&
            !properties.__is_winter_product
          ) {
            let incrementalSaleProperties = null;
  
            // Check for incremental sale qualify product
            if (bundleItemCount < 5) {

              let saleActivePrice = null;
              let saleType = 'SALE';
              if (priceTiers && priceTiers.length > 0) {
                for (const priceTier of priceTiers) {
                  if (priceTier.product_types.includes(productType)) {
                    saleActivePrice = priceTier.prices[bundleItemCount];
                    saleType = 'FIXED';
                    break;
                  }
                }

              } else {
                saleActivePrice = this.settings.startingPricePoint - bundleItemCount;
              }

              // Check if offer price is lower than origina item price
              if (saleActivePrice && saleActivePrice < cartItemPrice) {
                incrementalSaleProperties = {
                  offerCode,
                  type: saleType,
                  price: parseFloat(saleActivePrice) * 100,
                  lineItemIndex: bundleItemCount,
                  saleName
                };
                bundleItemCount += 1;
  
                // Increamental apply only for 1 quantity
                thisItem.quantity = 1;
              }
  
            } else { // Fall back price after bundle completion

              const productCustomSale = settings.productPrices.find((p) => 
                p.product_types.includes(thisItem.product_type)
              );

              if (productCustomSale) {

                // const fixedPrice = parseInt(applicableFixedPriceProductTypes[productType], 10) * 100;
                const fixedPrice = Number(productCustomSale.price).toFixed(2);
    
                if (fixedPrice < cartItemPrice) {
                  incrementalSaleProperties = {
                    productType,
                    offerCode,
                    type: 'FIXED',
                    price: parseFloat(fixedPrice) * 100,
                    saleName,
                  };
                }
              }
            }

            if (incrementalSaleProperties) {
              properties.__incremental_sale = incrementalSaleProperties;
            }
          }
        }

        Alpine.store('cart').pushTempItemsToCart();
      })
    },

    get bundleItemsByIndex() {
      const bundleItems = [];
      for(const item of this.bundleItems) {
        const offerIndex = item.properties.attributes.__incremental_sale.lineItemIndex;
        bundleItems[offerIndex] = item;
      }

      return bundleItems;
    },
    
    get bundleItems() { 
      return Alpine.store('cart').cartItems.filter(i => this.isBundleItem(i));
    },
    get bundleFallbackItems() { 
      return Alpine.store('cart').cartItems.filter(i => this.isBundleFallbackItem(i));
    },
    isBundleFallbackItem(item) { 
      const sale = item.properties.attributes.__incremental_sale;
      return sale && sale.offerCode != 'v2' && sale.type == 'FIXED';
    },
    isBundleItem(item) {
      const sale = item.properties.attributes.__incremental_sale;
      return sale && (sale.type == 'SALE' || (sale.offerCode == 'v2' && sale.type == 'FIXED' && sale.lineItemIndex < 5))
    },
    get bundleItemVariantIds() {
      return this.bundleItems.map(i => i.variant_id);
    },
    get activePrice() {
      return !this.isCompleted && this.settings ? this.settings.startingPricePoint - this.bundleItems.length : null;
    },
    get isCompleted() {
      return this.bundleItems.length >= 5;
    },
    get processSteps() {
      const steps = [false, false, false, false, false];

      const itemCount = this.bundleItems.length;

      if (itemCount === 0) {
        return steps;
      }

      for (let i = 0; i < 5; i += 1) {
        if (this.bundleItemsByIndex[i]) {
          steps[i] = true;
        }
      }

      return steps;
    },
    closeSuccessPopup() {
      Alpine.store('incrementalSale').showSuccessPopup = false;

      const { saleDetails } = Alpine.store('incrementalSale');
      const { baseURL } = Alpine.store('URL');

      // Check if sale target collection
      if (saleDetails.targetCollection != baseURL) {
        window.location.href = saleDetails.targetCollection;
      }
    }
  });

  // Use this v2 as hierarchy of incrementalSale
  Alpine.store('incrementalSaleV2', {
    settings: null,
    showSuccessPopup: false,
    offerSwitched: false,
    saleDetails: null,

    init() {
      // console.log('incrementalSaleV2 init');
      const incrementalSaleConfigScript = document.querySelector('#incremental_sale_v2_config[type="application/json"]');
      if (incrementalSaleConfigScript) {

        try {
          this.settings = JSON.parse(incrementalSaleConfigScript.textContent);

          const { convertLocal } = Alpine.store('currency');

          // Fallback prices
          this.settings.productPrices = this.settings.fallback_prices.map(p => {
            return {
              product_types: p.product_types.split('\n').filter(t => t.trim()),
              price: convertLocal(p.price),
            }
          });

          const priceTiers = this.settings.price_tiers.map(p => {
            return {
              display_name: p.display_name,
              product_types: p.product_types,
              price_1st_product: convertLocal(p.price_1st_product),
              price_2nd_product: convertLocal(p.price_2nd_product),
              price_3rd_product: convertLocal(p.price_3rd_product),
              price_4th_product: convertLocal(p.price_4th_product),
              price_5th_product: convertLocal(p.price_5th_product),
            }
          });

          this.settings.price_tiers = priceTiers;

          // Save to cookie
          setLifCookie('LIF-PARAM-IncrementalSaleSettings', JSON.stringify(this.settings), 2);

          // define sale expiry date
          todayMidNight = new Date();
          todayMidNight.setHours(24, 0, 0, 0); // next midnight

          tommMidNight = new Date();
          tommMidNight.setHours(48, 0, 0, 0); // tom midnight

          offerExpiryTime = tommMidNight.getTime();
          timerExpiryTime = todayMidNight.getTime();

          this.saleDetails = {
            saleName: this.settings.name,
            saleExpiry: { offerExpiryTime, timerExpiryTime },
            targetCollection: window.location.origin + window.location.pathname,
            offerCode: 'v2',
          };

          // Check if offer is already activate
          const existingSaleDetails = getLifCookie('LIF-PARAMS--INCREAMENTAL_SALE');
          if (existingSaleDetails) {
            const saleDetails = JSON.parse(existingSaleDetails);
            if (saleDetails.saleName != this.saleDetails.saleName) {
              this.offerSwitched = true;  
            }
          } else {
            this.offerSwitched = true;
          }

          setLifCookie('LIF-PARAMS--INCREAMENTAL_SALE', JSON.stringify(this.saleDetails), 2);

          console.log(this.saleDetails);
        } catch(error) {
          console.error(error);
        };
      } else {
        // console.log('No script found to parse: ');
        // console.log(incrementalSaleConfigScript);
      }

      Alpine.store('incrementalSale').refreshOffer();
      if (!this.settings) {
        const { saleDetails, settings } = Alpine.store('incrementalSale');
        this.settings = settings;
        this.saleDetails = saleDetails;
      }
    },

    get activeIndex() {
      if (!Alpine.store('incrementalSale').bundleItemsByIndex) {
        return null;
      }

      for (let i = 0; i < 5; i++) {
        if (!Alpine.store('incrementalSale').bundleItemsByIndex[i]) {
          return i;
        }
      }
    },
    get priceTiers() {
      const tiers = [];
      if (!this.settings || !this.settings.price_tiers) {
        return tiers;
      }

      for (const priceTier of this.settings.price_tiers) {
        tiers.push({
          display_name: priceTier.name,
          prices: [priceTier.price_1st_product, priceTier.price_2nd_product, priceTier.price_3rd_product, priceTier.price_4th_product, priceTier.price_5th_product],
          product_types: priceTier.product_types.split('\n').filter(t => t.trim()),
        });
      }

      return tiers;
    },
    deleteBundleItem(key) {
    
      const { bundleItems, bundleFallbackItems } = Alpine.store('incrementalSale');
      const deleteKeys = {};
      const remainingItems = [];

      // Let's delete all items re-add after price adjustment excpet final deleted item
      for (const bundleItem of [...bundleItems, ...bundleFallbackItems]) {
        deleteKeys[bundleItem.key] = 0;

        if (bundleItem.key != key) {
          remainingItems.push(bundleItem);
        }
      }

      // Rearrange the remaining item price based on position and product types
      const items = [];
  
      for (let i = 0; i < remainingItems.length; i += 1) {

        const { variant_id, properties, quantity, product_type } = remainingItems[i];

        let saleActivePrice = null;
        let saleType = 'SALE';

        if (this.priceTiers && this.priceTiers.length > 0) {
          
          for (const priceTier of this.priceTiers) {
            if (priceTier.product_types.includes(product_type)) {
              saleActivePrice = priceTier.prices[i];
              saleType = 'FIXED';
              break;
            }
          }
        } else if (i < 5) {
          saleActivePrice = this.settings.startingPricePoint - i;
        }

        if (saleActivePrice) {
          // calculate price based in level and product type
          properties.attributes.__incremental_sale.price = parseFloat(saleActivePrice) * 100;
          properties.attributes.__incremental_sale.lineItemIndex = i;
          properties.attributes.__incremental_sale.type = saleType;
        }

        items.push({ id: variant_id, properties: properties.attributes, quantity });
      }

      Alpine.store('cart').isCartInProgress = true;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: deleteKeys })
      })
      .then(() => {
        if (items.length > 0) {
          console.log('Sending items to add...');
          Alpine.store('cart').addItems(items, null, true, false);
        } else {
          Alpine.store('cart').loadItems(); // Re-load items after adding
        }
      });
    }
  });

  Alpine.store('buyMoreSaveMoreOffer', {
    isActive: false,
    buyMoreDiscounts: [],
    currentDiscountPercentage: 0,
    isHighestDiscountReached: false,
    pdpSelectedQuantity: 1,
    buyMoreBundleItemsSplitedQty: 0,

    deactivateOtherOffers() {
      deactivateOtherOffersIfActive([], ['__buy_more_bundle_item'])
      .then(() => {
        Alpine.store('sale').refreshOffers();
      });
    }
  });

  Alpine.store('buyMoreGetFreeOffer', {
    isActive: false,
    freeItemQtyThresholds: [],
    pdpSelectedQuantity: 1,
    highestDiscountQty: null,
    applicableProductTypes: [],

    init() {
      this.initOffer();
    },

    initOffer() {

      if (window.tc_v2) {
        this.applicableProductTypes = window.tc_v2.applicable_product_types;
      }

      // Get from settings cookie 
      const qtyThresholds = getLifCookie('LIF-PARAMS--FREE-ITEM-QTY-THRESHOLD');
      if (qtyThresholds) {
        this.freeItemQtyThresholds = JSON.parse(qtyThresholds);
      }

      this.highestDiscountQty = this.freeItemQtyThresholds[this.freeItemQtyThresholds.length - 1];
    },
    get bundleItemCount() {
      // return this.buyMoreBundleItems.length;
      // const { buyMoreBundleItemsSplitedQty, pdpSelectedQuantity } = Alpine.store('buyMoreGetFreeOffer');
      return this.buyMoreBundleItemsSplitedQty.length + this.pdpSelectedQuantity;
    },
    get isHighestDiscountReached() {
      return this.bundleItemCount >= this.highestDiscountQty;
    },

    get upcomingThresholds() {
      return this.freeItemQtyThresholds.find(d => d > this.bundleItemCount);
    },
    get matchedThresholds() {
      return this.freeItemQtyThresholds.filter(d => d <= this.buyMoreBundleItemsSplitedQty.length);
    },

    get buyMoreBundleItems() {
      return Alpine.store('cart').cartItems.filter((i) => i.properties.attributes.__buy_more_get_free);
    },
    get buyMoreFreeItems() {
      return Alpine.store('cart').cartItems.filter((i) => i.properties.attributes.__buy_more_get_free && i.line_price == 0);
    },
    get buyMoreBundleItemsSplitedQty() {
      const bundleItems = [];
      for (const item of this.buyMoreBundleItems) {

        // Consider each quantity as seperate bundle item
        for(let i = 0; i < parseInt(item.quantity); i++) {
          bundleItems.push(item)
        }
      }

      return bundleItems;
    },
    get buyMoreFreeItemsSplitedQty() {
      const bundleItems = [];
      for (const item of this.buyMoreFreeItems) {

        // Consider each quantity as seperate bundle item
        for(let i = 0; i < parseInt(item.quantity); i++) {
          bundleItems.push(item)
        }
      }

      return bundleItems;
    },

    // async addFreeItem(variantId, qty, index) {

    //   const freeItems = [];
    //   for(let i = 0; i < qty; i++) {
    //     const freeItem = {
    //       id: variantId,
    //       quantity: 1,
    //       properties: {
    //         __buy_more_get_free: {
    //           isActive: true,
    //           quantityThresholds: this.freeItemQtyThresholds,
    //           isFreeProduct: true,
    //           freeProductIndex: index + i
    //         },
    //         // __free_product_index: index + i,
    //         // __winter_bundle_sale_fixed_price: { 
    //         //   type: 'FIXED', 
    //         //   price: 0,
    //         //   saleName: 'Buy More Get Free'
    //         // }
    //       }
    //     }

    //     freeItems.push(freeItem);
    //   }

    //   await Alpine.store('cart').addItems(freeItems);
    // }
  });

  // Let's keep this at last so that all sale can accessible
  Alpine.store('sale', {
    hideMemberWidget: false,
    queryParams: [],

    init() {
      // console.log('sale init');
      this.processParameters();

      if (Alpine.store('customBundle').offerSwitched) {

        console.log('deactivateOtherOffers for customBundle');
        Alpine.store('customBundle').deactivateOtherOffers();

      } else if (Alpine.store('dynamicSale').offerSwitched) {

        console.log('deactivateOtherOffers for dynamicSale');
        Alpine.store('dynamicSale').deactivateOtherOffers();

      } else if (Alpine.store('offer1Free').offerSwitched) {

        console.log('deactivateOtherOffers for offer1Free');
        Alpine.store('offer1Free').deactivateOtherOffers();

      } else if (Alpine.store('offerFixedPrice').offerSwitched) {

        console.log('deactivateOtherOffers for offerFixedPrice');
        Alpine.store('offerFixedPrice').deactivateOtherOffers();
      } else if (Alpine.store('blackFridaySale').offerSwitched) {

        console.log('deactivateOtherOffers for blackFridaySale: ');
        console.log('URL: '+Alpine.store('URL').baseURL);
        Alpine.store('blackFridaySale').deactivateOtherOffers();

      } else if (Alpine.store('incrementalSale').offerSwitched) {

        console.log('deactivateOtherOffers for incrementalSale');
        Alpine.store('incrementalSale').deactivateOtherOffers();
      } else if (Alpine.store('incrementalSaleV2').offerSwitched) {

        console.log('deactivateOtherOffers for incrementalSaleV2');
        Alpine.store('incrementalSale').deactivateOtherOffers();
      } else if (Alpine.store('fwpOffer').offerSwitched) {

        console.log('deactivateOtherOffers for fwpOffer');
        Alpine.store('fwpOffer').deactivateOtherOffers();

      } else if (Alpine.store('buyMoreSaveMoreOffer').isActive) {
        console.log('deactivateOtherOffers for buyMoreSaveMoreOffer');
        Alpine.store('buyMoreSaveMoreOffer').deactivateOtherOffers();
      } else {
        this.refreshOffers();
      }

      const customBundle = Alpine.store('customBundle').saleDetails;
      
      if ((customBundle && Object.keys(customBundle).length !== 0 )
        || Alpine.store('incrementalSale').saleDetails
        || Alpine.store('blackFridaySale').saleDetails
        || Alpine.store('buyMoreSaveMoreOffer').isActive
      ) {
        this.hideMemberWidget = true;
      } else {
        this.hideMemberWidget = false;
      }
    },

    get refreshOnATC() {
      const customBundle = Alpine.store('customBundle').saleDetails;
      
      if ((customBundle && Object.keys(customBundle).length !== 0 )
        || Alpine.store('incrementalSale').saleDetails
        || Alpine.store('blackFridaySale').saleDetails) {
        return true;
      }
    },

    processParameters() {
      Alpine.store('URL').queryParams.forEach((param) => {
        switch (param[0]) {
          case 'sidecard' : // Check if parameter is passed for dynamic sale
            setLifCookie('LIF-PARAMS--SIDE_CARD_DEBUG', 1, 2);
            break;
          case 'no-offer' : // Check if parameter is passed for no offer
            deactivateOtherOffersIfActive();
            break;
          case 'first' : // Check if first product id parameter is passed
            if (window.__LIF__.is_enable_1st_collection_product_with_url 
              && window.location.pathname.includes('/collections/')) {
                
              const firstProductSettings = {
                targetCollection: window.location.pathname,
                productId: param[1],
              };

              window.sessionStorage.setItem('LIF-PARAMS--FIRST_PRODUCT_SETTINGS', JSON.stringify(firstProductSettings));
            }
            break;
          default:
            Alpine.store('URL').params[param[0]] = param[1];
            break;
        }
      });

      const firstProductSettings = window.sessionStorage.getItem('LIF-PARAMS--FIRST_PRODUCT_SETTINGS');
      if (firstProductSettings) {
        Alpine.store('collection').firstProductSettings = JSON.parse(firstProductSettings);
        Alpine.store('collection').loadFirstProduct();
      }
    },

    refreshOffers() {
      const sideCardDebug = getLifCookie('LIF-PARAMS--SIDE_CARD_DEBUG');
      if (sideCardDebug) {
        Alpine.store('cart').isSideCartOpen = true;
      }

      Alpine.store('offer1Free').refreshOffer();
      Alpine.store('offerFixedPrice').refreshOffer();
      Alpine.store('dynamicSale').refreshOffer();
      Alpine.store('customBundle').refreshOffer();
      Alpine.store('fwpOffer').refreshOffer();
      Alpine.store('blackFridaySale').refreshOffer();
      Alpine.store('incrementalSale').refreshOffer();
    },

    get bfDealActive() {
      return (Alpine.store('incrementalSale') && Alpine.store('incrementalSale').saleDetails && !!Alpine.store('incrementalSale').saleDetails.saleName)
      || (Alpine.store('blackFridaySale') && Alpine.store('blackFridaySale').isActive); 
    },

    get incrementalSaleActive() {
      return (Alpine.store('incrementalSale') && Alpine.store('incrementalSale').saleDetails && !!Alpine.store('incrementalSale').saleDetails.saleName);
    },
  });
});